import {HttpContextToken} from '@angular/common/http';

export const SKIP_EXCEPTION_HANDLING = new HttpContextToken<boolean>(() => false);
